import makeStyles from '@material-ui/styles/makeStyles';

const style = makeStyles(() => ({
    farmerImage: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        size: '100%',
    },
    image: {
        width: '35px',
        height: '35px',
        borderRadius: '50%',
        position: 'relative',
        overflow: 'hidden',
    },
    contactListSection: {
       
        alignItems: 'center',
       
        marginBottom: 10,
    },
    mlAuto: {
        marginLeft: 'auto',
        '& svg': {
            padding: 10,
            background: '#53252f',
            width: 16,
            height: 16,
            borderRadius: '50%',
            fill: '#fff',
            marginLeft: 10,
            '&+ svg': {
                background: 'green'
            }
        }
    },
    alignFront:{
        justifyContent: 'space-between',
        flexDirection: 'row',
        display: 'flex',
        width: '100%',
        padding:10,
        
    },
    oneByOne: {

        boxShadow: '0 0 10px #ddd',
        borderRadius: '6px',
    },
    contentBox: {
        background: '#fff',
        padding: 10,
        boxSizing: 'border-box',
    },
}));

export default style;
